import Grid from '@mui/material/Grid';
import React, { useState, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import {Select, MenuItem} from '@mui/material';
import axios from "axios";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import InputAdornment from '@mui/material/InputAdornment';
import NumberFormat from 'react-number-format';
import ChangeCompany from "./changeCompany/index.js";
import ConfirmCompany from "./ConfirmCompany/index.js";
import Step1 from "./Step1.js";
import Dialog from '@mui/material/Dialog';
import KlienChange from "./klienchange.js"; 
import Button from '@mui/material/Button';
import UpdateConfirmPopUpCallCenter from "./UpdateConfirmPopUpCallCenter.js"; 
import PhoneInput, { getCountries, getCountryCallingCode, isValidPhoneNumber } from 'react-phone-number-input';
import NewPIPopUp from "./NewPIPopUp.js"; 
import { useNavigate } from 'react-router-dom';


const NumberFormatCustom = React.forwardRef(function NumberFormatCustom(props, ref) {
  
  const { onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      prefix="Rp."
    />
  );
});

const ExtendCallCenter = ({contractData, setContractData, passed}) => {

  

  const [currentStep, setCurrentStep] = useState(1);
  const [progressTracker, setProgressTracker] = useState(0);
  const [selectedType, setSelectedType] = useState();
  const [klienID, setklienID] = useState(null);
  const [companyID, setcompanyID] = useState(null);
  const [statusEdit, setStatusEdit] = useState("Pembuatan Kontrak");
  const [berakhirSebelumnya, setBerakhirSebelumnya] = useState();

  useEffect(()=>{
    if(passed.state.stuff !== ""){
      setStatusEdit("Edit Kontrak");
      setSelectedType(passed.state.data.TipeKontrak);
      setklienID(passed.state.data.KlienID);
      setcompanyID(passed.state.data.CompanyID);
      getCategorias();
      setPPNnominal("Rp. " + (parseInt(contractData.GrandTotal)-parseInt(contractData.BiayaSebelumPPN)).toLocaleString("id-ID"))
      setBerakhirSebelumnya(contractData.TanggalBerakhir)
      let TanggalBerakhir = new Date(contractData.TanggalBerakhir);
      let newEndDate
      if(contractData.UnitDurasi === "Tahun"){
        newEndDate = new Date(TanggalBerakhir.getFullYear() + parseInt(contractData.DurasiKontrak), TanggalBerakhir.getMonth(), TanggalBerakhir.getDate() + 2);
      }else{
        newEndDate = new Date(TanggalBerakhir.getFullYear(), TanggalBerakhir.getMonth() + parseInt(contractData.DurasiKontrak),TanggalBerakhir.getDate() + 2);
      }  
      let newStartDate
      newStartDate = new Date(TanggalBerakhir.getFullYear(), TanggalBerakhir.getMonth(), TanggalBerakhir.getDate() + 1)
      setContractData({...contractData, TanggalMulai: newStartDate, TanggalBerakhir:newEndDate, PaidInvoiceList: [""]});
    }
  }, [passed]);

  function nextButton(){
    if (currentStep !== 5) {
      setProgressTracker(((currentStep)/5)*100);
      setCurrentStep(currentStep+1);
    }
  }
  const [isEditable, setIsEditable] = useState({});

  const handleEditClick = (field) => {
    setIsEditable(prevState => {
      const newState = { ...prevState }; // copy all fields
      for (let key in newState) {
        if (key !== field) newState[key] = false; // if it's not the field we're toggling, set it to false
      }
      newState[field] = !prevState[field]; // toggle the field we're interested in
      return newState;
    });
  }
  

  function prevButton(){
    if (currentStep !== 1) {
      setProgressTracker(((currentStep-2)/5)*100);
      setCurrentStep(currentStep-1);
    }
  }
  const handleInputChange = (field, event) => {
    setContractData({...contractData, [field]: event.target.value});  // Changed this line  
  }

  const handleNetSetelahDiskon = (field, event) => {
    const value = event.target.value;
    if(value && value !== "0" && value !== "Rp.0"){
      setContractData({...contractData, [field]: value, StatusDiskon: "Yes"});
    }else{
      setContractData({...contractData, [field]: value, StatusDiskon: "No"});  // Changed this line 
    } 
  }

  const handleSebelumPPN = (field, event) => {
    if(focus==="sebelumPPN"){
    setContractData({...contractData, [field]: event.target.value, GrandTotal: (Math.floor(event.target.value*(1+(contractData.PersenPPN/100))))});  // Changed this line 
    setPPNnominal("Rp. " + (parseInt((Math.floor(event.target.value*(1+(contractData.PersenPPN/100)))))-parseInt(event.target.value)).toLocaleString("id-ID")) 
  }
  }

  const handleGrandTotal = (field, event) => {
    if(focus==="grandTotal"){
    setContractData({...contractData, [field]: event.target.value, BiayaSebelumPPN: (Math.floor(event.target.value/(1+(contractData.PersenPPN/100))))});  // Changed this line 
    setPPNnominal("Rp. " + (event.target.value-(Math.floor(event.target.value/(1+(contractData.PersenPPN/100))))).toLocaleString("id-ID")) 
  }
  }

  const handleppnPercent = (event) => {
    if(focus==="PPN"){
    setContractData({...contractData, PersenPPN: parseInt(event.target.value), GrandTotal: (Math.floor(contractData.BiayaSebelumPPN*(1+(parseInt(event.target.value)/100))))})
    setPPNnominal("Rp. " + (parseInt((Math.floor(contractData.BiayaSebelumPPN*(1+(parseInt(event.target.value)/100)))))-contractData.BiayaSebelumPPN).toLocaleString("id-ID")) 
    }
  }
  

  const handleTanggalMulaiChange = (field, event) => {
    let newContractData = {...contractData, [field]: event};
    let newEndDate;
  
    if(contractData.UnitDurasi === "Tahun"){
      newEndDate = new Date(event.getFullYear() + parseInt(contractData.DurasiKontrak), event.getMonth(), event.getDate() + 1);
    }else{
      newEndDate = new Date(event.getFullYear(), event.getMonth() + parseInt(contractData.DurasiKontrak), event.getDate() + 1);
    }
    
    newEndDate = newEndDate.toISOString();
    newContractData = {...newContractData, TanggalBerakhir: newEndDate};
    
    setContractData(newContractData); 
  }
  const navigate = useNavigate();

  
  const [address2, setAddress2] = useState();
  const [address3, setAddress3] = useState();
  const [categorias, setCategorias] = useState([]);
  const getCategorias = async () => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/addressOptions`,{
    }).then(response=>{
      setCategorias(response.data.pilihanAlamat);
  });
    //console.log(res);
  }
  const handleChangeAddress = (field,event) => {
      const alamatDicari = event.target.value
      axios.post(`${process.env.REACT_APP_BACKEND_URL}/confirm-address`,{
              alamatDicari
      }).then(response=>{
          console.log(response.data)
          setContractData({...contractData, [field]: alamatDicari, Address2: response.data.address2, Address3: response.data.address3, Phone:response.data.phone});
      });

  }
  const [focus, setFocus] = useState();
  const handleDurasiKontrak = (field,value) => {
    let newContractData = {...contractData, [field]: value};
    let newEndDate;
  
    let TanggalMulaiDate = new Date(contractData.TanggalMulai);
    
    if(contractData.UnitDurasi === "Tahun"){
      newEndDate = new Date(TanggalMulaiDate.getFullYear() + parseInt(value), TanggalMulaiDate.getMonth(), TanggalMulaiDate.getDate() + 1);
    }else{
      newEndDate = new Date(TanggalMulaiDate.getFullYear(), TanggalMulaiDate.getMonth() + parseInt(value), TanggalMulaiDate.getDate() + 1);
    }
  
    newEndDate = newEndDate.toISOString();
    newContractData = {...newContractData, TanggalBerakhir: newEndDate};
    setContractData(newContractData); 
  }

  const [changePerusahaanPopUPOpen, setchangePerusahaanPopUPOpen] = useState(false)

  const closechangePerusahaanPopUPOpen =()=> {
    setchangePerusahaanPopUPOpen(false)
  }
  const changePerusahaan = () => {
    setchangePerusahaanPopUPOpen(true)
    console.log("opening")
  }
  const [newPIOpen,setnewPIOpen] = useState(false);

  const ediNewPaidInvoice = () => {
    setnewPIOpen(true)
  }

  const newPIClose = () => {
    setnewPIOpen(false)
  }
  const [changeKlienPopUpOpen, setchangeKlienPopUpOpen] = useState(false);
  const changeKlienPopUpClose = () => {
    setchangeKlienPopUpOpen(false);
  }
  
  const handleUnitDurasiKontrak = (field,value) => {
    let newContractData = {...contractData, [field]: value};
    let newEndDate;
  
    let TanggalMulaiDate = new Date(contractData.TanggalMulai);
    
    if(value === "Tahun"){
      newEndDate = new Date(TanggalMulaiDate.getFullYear() + parseInt(contractData.DurasiKontrak), TanggalMulaiDate.getMonth(), TanggalMulaiDate.getDate() + 1);
    }else{
      newEndDate = new Date(TanggalMulaiDate.getFullYear(), TanggalMulaiDate.getMonth() + parseInt(contractData.DurasiKontrak), TanggalMulaiDate.getDate() + 1);
    }
  
    newEndDate = newEndDate.toISOString();
    newContractData = {...newContractData, TanggalBerakhir: newEndDate};
    setContractData(newContractData); 
  }

  const [PPNnominal, setPPNnominal] = useState();
  
  const [updateKontrakconfirmopen, setupdateKontrakconfirmopen] = useState(false);

  const extendKontrak = () => {
    console.log(contractData.PaidInvoiceList)
    if(!contractData.PaidInvoiceList || contractData.PaidInvoiceList.length === 0 || contractData.PaidInvoiceList[0] === "") {
            setError("Call Center Harus ada Paid Invoice")
      console.log("harus ada paid invoice")
    }else{
      setError("")
    console.log(contractData)
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/latestKontrakNum`)
    .then(response => {
      console.log(response.data);
      console.log(response.data.jumlah);
      var testestest = response.data.jumlah;
      console.log(testestest);
      var piAmountNow = parseInt(testestest) + 1;
      console.log(piAmountNow);
      console.log(contractData.TanggalMulai)
      var tanggalAwal = new Date(contractData.TanggalMulai)
      var piMonth = new Date(tanggalAwal).getMonth() + 1
      var piYear = new Date(tanggalAwal).getYear() + 1900
      var piDate = new Date(tanggalAwal).getDate()
      var PINumbnow = piYear + "." + piMonth + "-Kontrak-Zanio." + piAmountNow;
      console.log({ PINumbnow, piAmountNow });
  
      return axios.post(`${process.env.REACT_APP_BACKEND_URL}/saveExtendKontrakCallCenter`, {
       piAmountNow, PINumbnow, contractData
      })
      .then(response => {
        console.log(response.data._id)
        const kontrakid = response.data._id; // extract _id from response
        console.log("Ini PINUMBNOW yang mau di render "+PINumbnow)
        return axios.post(`${process.env.REACT_APP_BACKEND_URL}/renderKontrakVOfromDB`, {
          id: kontrakid // include _id here
        }, {
          responseType: "blob"
        });
      })
      .then(resp => {
        console.log(resp)
        const blob = new Blob([resp.data], { type: 'application/pdf' })
        var fileURLNew = URL.createObjectURL(blob);
        console.log(fileURLNew)
        window.open(fileURLNew, '_blank');
        navigate("/Kontrak")
      });
    }).catch(error => {
      console.error(error);
    });}
  }

  const closeupdateKontrakconfirmopen = () => {
    setupdateKontrakconfirmopen(false)
  }

  const [error,setError] = useState("")
  return ( 
    <Paper sx={{p:5, boxShadow:10}} md={12}>
      <Dialog open={changePerusahaanPopUPOpen} onClose={closechangePerusahaanPopUPOpen}>
        <ConfirmCompany closechangePerusahaanPopUPOpen={closechangePerusahaanPopUPOpen} setContractData={setContractData} contractData={contractData}/>
      </Dialog>
      <Dialog open={newPIOpen} onClose={newPIClose}>
        <NewPIPopUp changeKlienPopUpOpen={changeKlienPopUpOpen} newPIOpen={newPIOpen} newPIClose={newPIClose} changeKlienPopUpClose={changeKlienPopUpClose} setContractData={setContractData} contractData={contractData}/>
      </Dialog>
      <Dialog open={changeKlienPopUpOpen} onClose={changeKlienPopUpClose}>
        <KlienChange changeKlienPopUpOpen={changeKlienPopUpOpen} changeKlienPopUpClose={changeKlienPopUpClose} setContractData={setContractData} contractData={contractData}/>
      </Dialog>
      <Dialog open={updateKontrakconfirmopen} onClose={closeupdateKontrakconfirmopen}>
        <UpdateConfirmPopUpCallCenter updateKontrakconfirmopen={updateKontrakconfirmopen} closeupdateKontrakconfirmopen={closeupdateKontrakconfirmopen} changeKlienPopUpClose={changeKlienPopUpClose} setContractData={setContractData} contractData={contractData}/>
      </Dialog>
      <b>Data Kontrak Saat ini</b>
      <Grid container sx={{mt:2}}>
            <Grid md={3} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>Penjual/Seller</Grid>
            <Grid md={9} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>: {isEditable.sellerID 
              ? <Select value={contractData.sellerID} onChange={(e) => handleInputChange('sellerID', e)}><MenuItem value="PT. Kendali Mitra Sukses">PT. Kendali Mitra Sukses</MenuItem><MenuItem value="PT. Supardi Nethanel Husain">PT. Supardi Nethanel Husain</MenuItem></Select>
              : contractData.sellerID} <IconButton onClick={() => handleEditClick('sellerID')}><EditIcon sx={{ fontSize: 15 }} color="primary"/></IconButton> </Grid>
          </Grid>
          <Divider variant="inset" sx={{mt:5, mb:5}} />
          <Grid container sx={{mt:2}}>
            <Grid md={3} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>Tipe Kontrak:</Grid>
            <Grid md={9} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>: {selectedType}</Grid>
          </Grid>
          <Grid container sx={{mt:2}}>
            <Grid md={3} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>Nomor Kontrak Sebelumnya:</Grid>
            <Grid md={9} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>: {contractData.kontrakNum}</Grid>
          </Grid>
          <Grid container sx={{mt:2}}>
            <Grid md={3} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>Nama Klien/PIC</Grid>
            <Grid md={9} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>: {contractData.KlienNama} <IconButton onClick={() => setchangeKlienPopUpOpen(true)}><EditIcon sx={{ fontSize: 15 }} color="primary"/></IconButton></Grid>
          </Grid>
          <Grid container sx={{mt:2}}>
            <Grid md={3} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>Nama Perusahaan</Grid>
            <Grid md={9} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>: {contractData.CompanyName} <IconButton onClick={() => changePerusahaan()}><EditIcon sx={{ fontSize: 15 }} color="primary"/></IconButton></Grid>
          </Grid>
          <Divider variant="inset" sx={{mt:5, mb:5}} />
          <Grid container sx={{mt:2}}>
            <Grid md={3} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>Tanggal Expired</Grid>
            <Grid md={9} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>: {new Date(berakhirSebelumnya).toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' }).replace(/(\w+) (\d+), (\d+)/, '$2 $1 $3')}</Grid>
          </Grid>
          <Grid container sx={{mt:2}}>
            <Grid md={3} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>Tanggal Mulai</Grid>
            <Grid md={9} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>: {isEditable.TanggalMulai 
              ? <LocalizationProvider dateAdapter={AdapterDateFns}>

<MobileDatePicker 
    views={['year', 'month', 'day']}
    inputFormat="dd/MM/yyyy"
    value={contractData.TanggalMulai}
    onChange={event => handleTanggalMulaiChange('TanggalMulai',event)}
    renderInput={(params) => 
        <TextField 
            {...params} 
            InputProps={{
                endAdornment: (
                    <InputAdornment >
                        <CalendarMonthIcon />
                    </InputAdornment>
                ),
            }}
        />
    }
/>

</LocalizationProvider>
              : new Date(contractData.TanggalMulai).toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' }).replace(/(\w+) (\d+), (\d+)/, '$2 $1 $3')} <IconButton onClick={() => handleEditClick('TanggalMulai')}><EditIcon sx={{ fontSize: 15 }} color="primary"/></IconButton></Grid>
          </Grid>
          <Grid container sx={{mt:2}}>
    <Grid md={3} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>Durasi Kontrak</Grid>
    <Grid md={9} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>
      : {isEditable.DurasiKontrak 
          ? <>
          <TextField value={contractData.DurasiKontrak} type="number" onChange={event=> handleDurasiKontrak("DurasiKontrak", event.target.value)}></TextField>
          <Select value={contractData.UnitDurasi} onChange={event => handleUnitDurasiKontrak("UnitDurasi", event.target.value)}>

                <MenuItem value="Bulan">Bulan</MenuItem>
                <MenuItem value="Tahun">Tahun</MenuItem>
              </Select>
            </>
          : `${contractData.DurasiKontrak} ${contractData.UnitDurasi}`} 
      <IconButton onClick={() => handleEditClick('DurasiKontrak')}>
        <EditIcon sx={{ fontSize: 15 }} color="primary"/>
      </IconButton>
    </Grid>
</Grid>

          <Grid container sx={{mt:2}}>
            <Grid md={3} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>Tanggal Berakhir</Grid>
            <Grid md={9} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>: {new Date(contractData.TanggalBerakhir).toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' }).replace(/(\w+) (\d+), (\d+)/, '$2 $1 $3')}</Grid>
          </Grid>
          <Grid container sx={{mt:2}}>
            <Grid md={3} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>Nomor Telepon Disewa</Grid>
            <Grid md={9} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>: {isEditable.nomorTeleponSewa 
            ? <PhoneInput
                                international
                                defaultCountry="ID"
                                value={contractData.nomorTeleponSewa}
                                placeholder="Nomor Telepon"
                                onChange={event => handleInputChange("nomorTeleponSewa" , event)}
                              />
            : contractData.nomorTeleponSewa} <IconButton onClick={() => handleEditClick('nomorTeleponSewa')}><EditIcon sx={{ fontSize: 15 }} color="primary"/></IconButton></Grid>
          </Grid>
          <Grid container sx={{mt:2}}>
            <Grid md={3} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>Tipe Telepon</Grid>
            <Grid md={9} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>: {isEditable.tipeTelepon 
            ? <Select value={contractData.tipeTelepon} onChange={event => handleInputChange("tipeTelepon" , event)}><MenuItem value="Shared Phone Number">Shared Phone Number</MenuItem><MenuItem value="Dedicated Phone Number">Dedicated Phone Number</MenuItem></Select>
            : contractData.tipeTelepon} <IconButton onClick={() => handleEditClick('tipeTelepon')}><EditIcon sx={{ fontSize: 15 }} color="primary"/></IconButton></Grid>
          </Grid>
          <Grid container sx={{mt:2}}>
            <Grid md={3} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>Tipe Forwarding</Grid>
            <Grid md={9} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>: {isEditable.tipeForwarding 
            ? <Select value={contractData.tipeForwarding} onChange={event => handleInputChange("tipeForwarding" , event)}><MenuItem value="Cold Forwarding">Cold Forwarding</MenuItem><MenuItem value="Warm Forwarding">Warm Forwarding</MenuItem></Select>
            : contractData.tipeForwarding} <IconButton onClick={() => handleEditClick('tipeForwarding')}><EditIcon sx={{ fontSize: 15 }} color="primary"/></IconButton></Grid>
          </Grid>
          <Grid container sx={{mt:2}}>
            <Grid md={3} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>Tipe Answering</Grid>
            <Grid md={9} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>: {isEditable.tipeAnswering 
            ? <Select value={contractData.tipeAnswering} onChange={event => handleInputChange("tipeAnswering" , event)}><MenuItem value="Aplikasi">Aplikasi</MenuItem><MenuItem value="Pulsa">Pulsa</MenuItem></Select>
            : contractData.tipeAnswering} <IconButton onClick={() => handleEditClick('tipeAnswering')}><EditIcon sx={{ fontSize: 15 }} color="primary"/></IconButton></Grid>
          </Grid>
          <Grid container sx={{mt:2}}>
            <Grid md={3} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>Link Paid Invoice Terbaru:</Grid>
            <Grid md={9} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>: {contractData.PaidInvoiceList??"Belum Ada"}<IconButton onClick={() => ediNewPaidInvoice()}><EditIcon sx={{ fontSize: 15 }} color="primary"/></IconButton></Grid>
          </Grid>
          <Divider variant="inset" sx={{mt:5, mb:5}} />
          <Grid container sx={{mt:2}}>
            <Grid md={3} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>Pulsa</Grid>
            <Grid md={9} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>: {isEditable.pulsa
            ?  <TextField
                                name="Sebelum PPN"
                                placeholder="Sebelum PPN"
                                value= {contractData.BiayaSebelumPPN}
                                onChange= {event => handleInputChange("pulsa",event)}
                                InputProps={{inputComponent: NumberFormatCustom, style:{fontWeight: 'bold', fonrSize:"16px"}}}
                                
                            />
            : "Rp. " + parseInt(contractData.pulsa).toLocaleString("id-ID")} <IconButton onClick={() => handleEditClick('pulsa')}><EditIcon sx={{ fontSize: 15 }} color="primary"/></IconButton></Grid>
          </Grid>
          <Grid container sx={{mt:2}}>
            <Grid md={3} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>Harga Sebelum PPN</Grid>
            <Grid md={9} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>: {isEditable.BiayaSebelumPPN
            ?  <TextField
                                name="Sebelum PPN"
                                placeholder="Sebelum PPN"
                                value= {contractData.BiayaSebelumPPN}
                                onFocus= {event => setFocus("sebelumPPN")}
                                onChange= {event => handleSebelumPPN("BiayaSebelumPPN",event)}
                                InputProps={{inputComponent: NumberFormatCustom, style:{fontWeight: 'bold', fonrSize:"16px"}}}
                                
                            />
            : "Rp. " + parseInt(contractData.BiayaSebelumPPN).toLocaleString("id-ID")} <IconButton onClick={() => handleEditClick('BiayaSebelumPPN')}><EditIcon sx={{ fontSize: 15 }} color="primary"/></IconButton></Grid>
          </Grid>
          <Grid container sx={{mt:2}}>
            <Grid md={3} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>PPN</Grid>
            <Grid md={9} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>: {PPNnominal} ({isEditable.PersenPPN
            ? <NumberFormat customInput={TextField} 
                                variant="outlined"
                                thousandSeparator={true}
                                suffix={'%'}
                                value={contractData.PersenPPN}
                                onChange={event => handleppnPercent(event)}
                                onFocus={event => setFocus("PPN")}
                                autoComplete="off"/>
            : `${contractData.PersenPPN} %`}) <IconButton onClick={() => handleEditClick('PersenPPN')}><EditIcon sx={{ fontSize: 15 }} color="primary"/></IconButton></Grid>
          </Grid>
          <Grid container sx={{mt:2}}>
            <Grid md={3} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>Grand Total</Grid>
            <Grid md={9} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>: {isEditable.GrandTotal 
                ? <TextField
                                name="Sebelum PPN"
                                placeholder="Sebelum PPN"
                                value={contractData.GrandTotal} onFocus={event => setFocus("grandTotal")} onChange={(e) => handleGrandTotal('GrandTotal', e)}
                                InputProps={{inputComponent: NumberFormatCustom, style:{fontWeight: 'bold', fonrSize:"16px"}}}
                                
                            />
                : "Rp. " + parseInt(contractData.GrandTotal).toLocaleString("id-ID")} <IconButton onClick={() => handleEditClick('GrandTotal')}><EditIcon sx={{ fontSize: 15 }} color="primary"/></IconButton></Grid>
          </Grid>
          <Grid container sx={{mt:2}}>
            <Grid md={3} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>Harga Nett Setelah Diskon</Grid>
            <Grid md={9} sx={{ fontSize: "medium", fontFamily: "Open Sans, sans-serif" }}>: {isEditable.StatusDiskon
            ?  <TextField
                                name="Sebelum PPN"
                                placeholder="Sebelum PPN"
                                value={contractData.NetSetelahDiskon} onChange={(e) => handleNetSetelahDiskon('NetSetelahDiskon', e)}
                                InputProps={{inputComponent: NumberFormatCustom, style:{fontWeight: 'bold', fonrSize:"16px"}}}
                                
                            />
            : contractData.StatusDiskon === "No" ? "Tidak ada Diskon" : "Rp. " + parseInt(contractData.NetSetelahDiskon).toLocaleString("id-ID")} <IconButton onClick={() => handleEditClick('StatusDiskon')}><EditIcon sx={{ fontSize: 15 }} color="primary"/></IconButton></Grid>
          </Grid> 
          {error && <Grid className="error_text" sx={{mb:3}}>{error}</Grid>}
          <Button sx={{mt:3}} type="button" variant="contained" onClick={extendKontrak}>Extend</Button>

   </Paper>
  );
};

export default ExtendCallCenter;
